import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const LotTableBinRowSchema_ = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  quantity: z.number().int(),
});
export const LotTableBinRowSchema: z.ZodType<LotTableBinRow> =
  LotTableBinRowSchema_;
export interface LotTableBinRow extends z.infer<typeof LotTableBinRowSchema_> {}

const LotTableRowSchema_ = z.object({
  id: inventoryItemIdFormat.schema,
  accountId: z.string(),
  productId: productIdFormat.schema.nullable(),
  productTitle: z.string().nullable(),
  productSku: z.string().nullable(),
  productImage: z.string().nullable(),
  lotNumber: z.string().nullable(),
  expirationDate: z.coerce.date().nullable(),
  onHandQuantity: z.number(),
  bins: z.array(LotTableBinRowSchema),
  locationId: locationIdFormat.schema.nullable(),
  createdAt: z.coerce.date(),
});
export const LotTableRowSchema: z.ZodType<LotTableRow> = LotTableRowSchema_;
export interface LotTableRow extends z.infer<typeof LotTableRowSchema_> {}
